/** @jsx jsx */
import { jsx } from 'theme-ui'

// Error message shared by TextInput, TextArea, and Select fields
const ErrorMessage = ({ ...props }) => {
  return (
    <div
      {...props}
      sx={{ fontSize: 1, color: 'tomato', mb: 3, lineHeight: 1 }}
      data-automation-id="error-message"
    />
  )
}

// Helper text shared by TextInput, TextArea, and Select fields
const HelperText = ({ ...props }) => {
  return (
    <div
      {...props}
      sx={{ fontSize: 1, fontStyle: 'italic', color: 'muted', mb: 2 }}
    />
  )
}

export { ErrorMessage, HelperText }
